import React, { useState, useRef } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { Button, TextField } from '@mui/material'

const QRCode = () => {
  const [url, setUrl] = useState('')
  const [generate, setGenerate] = useState(false)
  const qrRef = useRef(null)

  const downloadQr = () => {
    const svg = qrRef.current.querySelector('svg')
    const serializer = new XMLSerializer()
    const svgStr = serializer.serializeToString(svg)
    const canvas = document.createElement('canvas')
    const img = new Image()

    const svgBlob = new Blob([svgStr], { type: 'image/svg+xml;charset=utf-8' })
    const url = URL.createObjectURL(svgBlob)

    img.onload = () => {
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      URL.revokeObjectURL(url)

      const pngUrl = canvas.toDataURL('image/png')
      const downloadLink = document.createElement('a')
      downloadLink.href = pngUrl
      downloadLink.download = 'qrcode.png'
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    }

    img.src = url
  }

  return (
    <div className='qrcodepage'>
      <h1 className='mb-40px mt-40px'>Generate QR Code</h1>
      <div className='d-flex justify-content-space-evenly align-items-center'>
        <div className='d-flex justify-content-center align-items-center flex-direction-column w-60'>
          <TextField
            value={url}
            placeholder='Enter your url'
            onChange={(e) => setUrl(e.target.value)}
            className='mb-20px w-60'
          />
          <Button
            onClick={() => setGenerate(true)}
            className='commonButton'
          >
            Generate
          </Button>
        </div>
        {
          generate &&
          <div
            className='d-flex justify-content-center align-items-center flex-direction-column'
            ref={qrRef}
          >
            <QRCodeSVG
              value={url}
              size={300}
              bgColor={"#ffffff"}
              fgColor={"#000000"}
              level={"L"}
            />
            <Button
              onClick={downloadQr}
              className='commonButton mt-20px'
            >
              Download
            </Button>
          </div>
        }
      </div>
    </div>
  )
}

export default QRCode
